import { appRoutes } from "@/app/router";
import { observer } from "mobx-react-lite";
import { FC } from "react";
import { Navigate } from "react-router-dom";
import { usePublicAppStore } from "@/store";
import { clientEnvModule } from "@/modules/client-env";
import { localStorageModule } from "@/modules/local-storage";
import { NodeEnvironment } from "@/domains/common/types";

interface LandingPageProps {}

export const LandingPage: FC<LandingPageProps> = observer(() => {
  const { publicStore } = usePublicAppStore();

  if (publicStore.auth.isAuthenticated) {
    return <Navigate to={appRoutes.notesList({}).path} />;
  }

  // Check if we should redirect to external landing page (first-time user in production)
  // If so, don't navigate to /login - let useRedirectToLandingPage hook handle it
  if (!clientEnvModule.isDesktop()) {
    const nodeEnv = clientEnvModule.nodeEnv();
    const isMainProdEnv = nodeEnv === NodeEnvironment.Production;

    if (isMainProdEnv && !localStorageModule.hasPreviouslyVisitedLoginPage()) {
      // First-time user in production - return null to prevent /login navigation
      // The useRedirectToLandingPage hook in RootOutlet will handle the redirect
      return null;
    }
  }

  return <Navigate to={appRoutes.logIn({}).path} />;
});
